import StoreProductImageFillSrc from "~/assets/img/store-product-image-cover.png";
import {IIconBase} from "~/components/icons/_common/types";

interface BmStoreProductImageFillProps extends Omit<IIconBase, "size"> {}

export const BmStoreProductImageFill: React.FC<BmStoreProductImageFillProps> = ({id, className}) => {
  return <img src={StoreProductImageFillSrc} id={id} alt="Store product fill" className={className} />;
};
